export default __webpack_public_path__ + "static/media/fire.82efa8e1.gif";